import { Environment, Network, RecordSource, Store, IEnvironment } from 'relay-runtime'
import { RequestParameters } from 'relay-runtime/lib/util/RelayConcreteNode'
import { Variables } from 'relay-runtime/lib/util/RelayRuntimeTypes'
import { fetchGraphQL } from './fetchGraphQL'

const createEnvironment = (): IEnvironment => {
  const handler = (request: RequestParameters, variables: Variables) =>
    fetchGraphQL(request, variables)
  const network = Network.create(handler)

  const env = new Environment({
    network,
    store: new Store(new RecordSource()),
  })
  return env
}

export default createEnvironment
